<script>
  export let searchFunction = (val) => [];
  export let aclist = [];
  export let placeholder = 'Please Select';
  export let selectedItem = {};
  export let value = '';
  export let valueName = '';
  export let select= '';
  export let id = '';
  /* handling the input */
  export let acInputVal = '';
  let searchInput; // use with bind:this to focus element
  let searchList;
  let check;
  let unselectDiv = 'ac-input';
  $: console.log('placeholder', placeholder);
  $: if ( placeholder == 'Please Select') {
      check = true;
  } else {
      check = false;
      unselectDiv = 'ac-input2';
      console.log('unselectDiv', unselectDiv);
  }
  const setInputVal = (item) => {
      if (!item) return;
      if (item.name2 !=undefined && item.name2!='') {
          //   acInputVal = item.name+' '+item.name2;
          acInputVal = item.name;
      } else {
          acInputVal = removeBold(item.name);
      }
      selectedItem = item;
      value = acInputVal;
      valueName = item.code;
      if (value==undefined) {
          value=item.name;
      }
      aclist = [];
      highlightIndex = null;
  };
  /**
   *
   */
  function updateACList() {
      // if (!acInputVal){
      //     return;
      // }
      searchFunction(acInputVal)
          .then((res) => (aclist = res))
          .catch((err) =>
              console.warn('search function returned error', err),
          );
  }
  /**
   *
   */
  function updateACList2() {
      acInputVal = '';
      searchFunction(acInputVal)
          .then((res) => (aclist = res))
          .catch((err) =>
              console.warn('search function returned error', err),
          );
  }
  const removeBold = (str) => {
      // replace < and > all characters between
      if (!str) {
          return str;
      } else {
          return str.replace(/<(.)*?>/g, '').replace(/<(strong)>/g, '').replace(/<\/(strong)>/g, '');
      }
  };
  /* navigating over the list of items w highlighting */
  let highlightIndex = null;
  // $: console.log(highlightIndex);
  const navigateList = (e) => {
      if (e.target.id !== searchInput.id) {
          return;
      }
      // console.log(e, e.target.id === searchInput.id);
      if (e.key === 'ArrowDown' && highlightIndex <= aclist.length - 1) {
          highlightIndex === null ?
              (highlightIndex = 0) :
              (highlightIndex += 1);
      } else if (e.key === 'ArrowUp' && highlightIndex !== null) {
          highlightIndex === 0 ?
              (highlightIndex = aclist.length - 1) :
              (highlightIndex -= 1);
      } else if (e.key === 'Enter') {
          e.stopPropagation();
          setInputVal(aclist[highlightIndex]);
      }
  };
</script>
<svelte:body
  on:keydown={navigateList}
  on:click|focus={(e) => {
      if (
          e.target !== searchInput &&
          e.target.parentElement &&
          e.target.parentElement !== searchList
      ) {
          aclist = [];
          if (selectedItem) {
              value = selectedItem.code;
              select=removeBold(selectedItem.name);
              acInputVal = select, value;
          }
      }
  }} />
<svelte:options accessors />

<div class="autocomplete" {id}>
    
        <input 
        
        class= {unselectDiv}
        {placeholder}
        bind:this={searchInput}
        bind:value={acInputVal}
        on:input={updateACList}
        on:focus={() => {
            updateACList();
        }}
        on:click={()=>{
        updateACList2();
        // console.log(" Button Clicked");
        }}
    />
    <div class="option_arrow"   
    on:click={() => {
        updateACList2();
        searchInput.focus();
    }}>
    <img src='images/dropdown.svg' alt=''>

    </div>
    {#if aclist.length > 0}
        <ul
            id="autocomplete-items"
            bind:this={searchList}
            class="autostyle"
        >
            {#each aclist as acitem, i}
                <li
                    class="autocomplete-item"
                    class:autocomplete-active={i === highlightIndex}
                    on:click={() => setInputVal(acitem)}
                >
                    {@html acitem.name}
                    {#if (acitem.name2 != undefined ) && (acitem.name2 != '' ) }
                    {@html acitem.name2}
                    {/if}
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
  div.autocomplete {
    position: relative;
  }
  input {
    border: 0.132vw solid rgba(171, 171, 171, 1);
    border-radius: 0.661vw;
    padding-left: 1vw;
    height: 2.7vw;
    font-size: 0.926vw;    
  }
  .autostyle{
    left: 0;
    width: 100%;
  }
  .ac-input {
    width: 18.915vw; 
    color: rgba(171, 171, 171, 1);
    padding-left: 1vw;
    height: 2.7vw;
    background-color: transparent;
    font-size: 0.926vw;
    border: 0.132vw solid rgba(171, 171, 171, 1);
    border-radius: 0.661vw;
    cursor: default;
    caret-color: transparent;
  }
  .ac-input2 {
    width: 18.915vw; 
    color:  black!important;
    padding-left: 1vw;
    height: 2.7vw;
    background-color: transparent;
    font-size: 0.926vw;
    border: 0.132vw solid rgba(171, 171, 171, 1);
    border-radius: 0.661vw;
    cursor: default;
    caret-color: transparent;
  }
  ::placeholder {
    font-size: 0.926vw;
  }
  .option_arrow {
    position: absolute;
    right: 0.4vw;
    top: 1.1vw;
    height: 0.49vw;
    width: 1vw;
    display: flex;
  }
  #autocomplete-items {
      position: absolute;
      padding: 0;
      color: white;
      cursor: default;
      border: 1px solid darkgrey;
      z-index: 3;
  }
  li.autocomplete-item {
      list-style: none;
      z-index: 99;
      /*position the autocomplete items to be the same width as the container:*/
      top: 100%;
      left: 0;
      right: 0;
      padding: 10px;
      cursor: pointer;
      background-color: white;
      color: black;
  }
  li.autocomplete-item:hover {
      /*when hovering an item:*/
      background-color: DodgerBlue;
      color: white;
  }
  li.autocomplete-item:active {
      /*when navigating through the items using the arrow keys:*/
      background-color: DodgerBlue !important;
      color: #FFFFFF;
  }
  .autocomplete-active {
      /*when navigating through the items using the arrow keys:*/
      background-color: DodgerBlue !important;
      color: #FFFFFF;
  }
  input:focus {
      box-shadow: none;
  }
@media screen and (max-width: 1024px) {
    .ac-input {
        width: 56.949vw;
        height: 9.111vw;
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        font-size: 3.187vw;
    }
    .ac-input2 {
        width: 56.949vw;
        height: 9.111vw;
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        font-size: 3.187vw;
    }
    ::placeholder {
        font-size: 3.187vw;
    }
    .option_arrow {
        position: absolute;
        right: 31vw;
        top: 3.4vw;
        height: 3vw;
        width: 3vw;
        display: flex;
    }
    .autostyle{
        width: 57.5vw;
    }
    li.autocomplete-item {
      top: 100%;
      left: 0;
      right: 0;
      padding: 2.336vw;
  }
}
</style>